import * as React from 'react';
import NewJobPricelistItemData from './NewJobPricelistItem';
import { ItemOptionList, NewJobQuoteItem, NewJobQuoteItemExtra, JobQuoteExtraItemOption, FencingStock, NewJobQuoteFenceQuestions, FenceAreaOption } from './models/JobInterfaces';
import { GenericList } from './models/JobSharedInterfaces';

interface NewJobPricelistEwsProps {
    isJobEvent: boolean;
    jobTypeId: number;
    customerQuoteNotesDunny: string;
    schedulePickup: boolean;
    lunchRoomExtraId: number;
    siteOfficeExtraId: number;
    customerPickup: number;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    tiltSlideClearance: number;
    accountTypeId: number;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    truckHireRate: number;
    fenceQuestions: NewJobQuoteFenceQuestions;
    extraItemOptions: JobQuoteExtraItemOption[];
    yesNoOptions: GenericList[];
    truckOptions: GenericList[];
    truckSideOptions: GenericList[];
    customerChargeFuelSurcharge: boolean;
    customerNewFuelInvoice: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    errors: { [key: string]: string };
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    updateTiltClearance(tiltSlideClearance: number): void;
}

const NewJobPricelistEwsData = (props: NewJobPricelistEwsProps) => {

    const handleTruckClearanceChange = (e: any) => {
        var value = e.target.value * 1;

        props.updateTiltClearance(value);

        if (value === 0) {
            //if there isn't enough clearance then we need to change the trucks to crane and re-calcualate the price

            //find crane truck
            var craneTruck = props.truckOptions.filter(t => t.name.toLowerCase() === 'crane');
            if (craneTruck.length > 0) {
                let craneTruckId = craneTruck[0].id;

                //update trucks to crane for every item
                for (var i = 0; i < props.quoteItems.length - 1; i++) {
                    let item = props.quoteItems[i];

                    item.truck = craneTruckId;

                    //udpate item and re-calculate price
                    props.updateQuoteItem(item, true);
                }
            }
        }
    }

    const isTiltSlide = props.quoteItems.filter(q => q.truck === 1).length > 0;
    const custPickup = props.customerPickup * 1;

    const pricelistItem = <NewJobPricelistItemData isJobEvent={props.isJobEvent} jobTypeId={props.jobTypeId} schedulePickup={props.schedulePickup}
        lunchRoomExtraId={props.lunchRoomExtraId} siteOfficeExtraId={props.siteOfficeExtraId} showLocation={false} showExtras={true} showCleaning={true} showBracing={false} showMaintenance={false} showTruck={true} showEpaItems={false} showAdditionalHire={true}
        customerPickup={custPickup} allowAllocateToPastDate={props.allowAllocateToPastDate} jobInstalled={props.jobInstalled} accountTypeId={props.accountTypeId} quoteItems={props.quoteItems} itemOptions={props.itemOptions}
        truckHireRate={props.truckHireRate} fenceQuestions={props.fenceQuestions} frequencyOptions={[]} extraItemOptions={props.extraItemOptions} yesNoOptions={props.yesNoOptions} truckOptions={props.truckOptions} truckSideOptions={props.truckSideOptions}
        chargeFuelSurchargeSwitchedOn={props.chargeFuelSurchargeSwitchedOn} customerNewFuelInvoice={props.customerNewFuelInvoice} customerChargeFuelSurcharge={props.customerChargeFuelSurcharge}
        addItem={props.addItem} deleteItem={props.deleteItem} updateQuoteItem={props.updateQuoteItem} />

    return (
        <div>
            <div className="newJobPricelist--customer-notes">{props.customerQuoteNotesDunny}</div>

            {pricelistItem}

            {props.errors["ewsQuoteItems"] ?
                (props.errors["ewsQuoteItems"]).split("\n").map((item: any, key: any) => {
                    return <span className="label errors" key={key}>{item}<br /></span>
                })
            : ""}
                
            <label className={isTiltSlide && custPickup === 0 ? "input-group" : "hidden"} htmlFor="tiltSlideClearance">
                <span className="label-large">Is there 17m clearance for Tilt Slide Truck?</span>
                <select className="select" id="tiltSlideClearance" name="tiltSlideClearance" value={props.tiltSlideClearance} onChange={(e) => handleTruckClearanceChange(e)}>
                    <option hidden defaultValue="-1"></option>
                    {props.yesNoOptions.map(yn =>
                        <option key={yn.id} value={yn.id}>{yn.name}</option>
                    )};
                </select>
            </label>
            <span className="label errors">{props.errors["tiltSlideClearance"]}</span>

        </div>
    )
}

export default NewJobPricelistEwsData;